var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$fetchState.pending)?_c('skeleton-loader-page-head'):_c('div',[_c('gym-page-header',{attrs:{"gym":_vm.gym}}),_vm._v(" "),_c('nuxt-child',{attrs:{"gym":_vm.gym}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }